import $ from 'jquery'
import {Core} from './core'

export class TemplateExalogSimulator {
  constructor() {
    this.$container = $('.template-exalog-simulator')

    if (!this.$container.length) {
      return
    }

    this.classes = {
      inputError: 'input-error'
    }

    this.formProvider = this.$container.data('form-provider') || 'marketo'
    this.odooFormId = this.$container.data('odoo-form-id')

    this.$form = this.$container.find('form.steps')
    this.$breadcrumb = this.$container.find('.steps-breadcrumb')
    this.$packInput = this.$container.find('input[name="pack"]')
    this.$bankAccountInput = this.$container.find('input[name="bank_account"]')
    this.$optionsInput = this.$container.find('input[name="options"]')
    this.$priceContent = this.$container.find('.price-content')
    this.$marketoForm = this.$container.find('.mktoForm')

    this.$firstname = this.$container.find('[name="firstname"]')
    this.$lastname = this.$container.find('[name="lastname"]')
    this.$enterprise = this.$container.find('[name="enterprise"]')
    this.$phone = this.$container.find('[name="phone"]')
    this.$email = this.$container.find('[name="email"]')

    this.$form.on('submit', this.handleSubmitForm.bind(this))
    this.$container.on('click', '.btn-prev', this.handleClickPrevButton.bind(this))
    this.$container.on('click', '.btn-next', this.handleClickNextButton.bind(this))
    this.$container.on('click', '.btn-restart', this.handleClickRestartButton.bind(this))
  }

  handleClickPrevButton(e) {
    e.preventDefault()

    let $step = this.$container.find('.step.active')
    let $prevStep = $step.prev()

    if ($prevStep.length) {
      $prevStep.addClass('active')
      $step.removeClass('active')
      this.updateBreadcrumb($prevStep)
    }
  }

  handleSubmitForm(e) {
    e.preventDefault()
  }

  handleClickNextButton(e) {
    e.preventDefault()
    let $step = this.$container.find('.step.active')
    let currentStepNumber = $step.data('step')

    if (this.verifyStep(currentStepNumber)) {
      let $nextStep = $step.next()

      if ($nextStep.length) {
        $step.removeClass('active')
        this.onShowStep($nextStep.data('step'))
        $nextStep.addClass('active')
        this.updateBreadcrumb($nextStep)
      }
    }
  }

  handleClickRestartButton(e) {
    e.preventDefault()
    let $stepFirst = this.$container.find('[data-step="1"')
    let $activeStep = this.$container.find('.step.active')

    $activeStep.removeClass('active')
    $stepFirst.addClass('active')

    this.onShowStep(1)
    this.updateBreadcrumb($stepFirst)
  }

  updateBreadcrumb($step) {
    let stepNumber = $step.data('step')
    let $items = this.$breadcrumb.find(`.item`)

    $items.removeClass('active')

    if (stepNumber > 4) {
      this.$breadcrumb.find(`.item[data-step="4"]`).addClass('active')
    } else {
      this.$breadcrumb.find(`.item[data-step="${stepNumber}"]`).addClass('active')
    }

    $items.each((index, item) => {
      let $item = $(item)
      let currentStepNumber = $item.data('step')

      if (currentStepNumber < stepNumber) {
        $item.html('<i class="icon icon-check"></i>')
      } else {
        $item.html(`${currentStepNumber}`)
      }
    })
  }

  onShowStep(stepNumber) {
    if (typeof this[`onShowStep${stepNumber}`] === 'function') {
      this[`onShowStep${stepNumber}`]()
    }
    if (Core.isBpLessThan('md')) {
      Core.scrollTo(this.$breadcrumb)
    }
  }

  onShowStep3() {
    this.$priceContent.find('.text').remove()
    this.$container.find('[data-step="3"] .btn-next').hide()

    let data = {
      action: 'vah_exalog_simulator',
      post_id: this.$container.data('post-id'),
      pack: this.$packInput.filter(':checked').val(),
      bank_account: this.$bankAccountInput.val(),
      options: this.$optionsInput.filter(':checked').map(function() {
        return $(this).val()
      }).get()
    }

    $.ajax({
      url: ajax_url.ajax_url,
      data: data,
      type: 'POST',
      dataType: 'json',
      success: this.showPriceSuccess.bind(this),
      error: this.showPriceError.bind(this),
    })
  }

  verifyStep(stepNumber) {
    this.$container.find('.error.active').removeClass('active')

    if (typeof this[`verifyStep${stepNumber}`] === 'function') {
      return this[`verifyStep${stepNumber}`]()
    }

    return true
  }

  verifyStep1() {
    let hasError = false
    let $packInput = this.$packInput.filter(':checked')

    this.$packInput.removeClass(this.classes.inputError)
    this.$bankAccountInput.removeClass(this.classes.inputError)

    if ($packInput.length === 0) {
      hasError = true
      this.$packInput.addClass(this.classes.inputError)
      this.$container.find('#empty_answer_error_pack').addClass('active')
    }

    if (this.$bankAccountInput.val() === '') {
      hasError = true
      this.$bankAccountInput.addClass(this.classes.inputError)
      this.$container.find('#empty_answer_error_bank_account').addClass('active')
    } else if (parseInt(this.$bankAccountInput.val()) <= 0) {
      hasError = true
      this.$bankAccountInput.addClass(this.classes.inputError)
      this.$container.find('#bad_type_answer_error_bank_account').addClass('active')
    }

    return !hasError
  }

  verifyStep4() {
    if (this.verifyForm()) {
      return ! this.sendForm()
    }

    return false
  }

  verifyForm() {
    let firstname = this.$firstname.val().trim()
    let lastname = this.$lastname.val().trim()
    let enterprise = this.$enterprise.val().trim()
    let phone = this.$phone.val().trim()
    let email = this.$email.val().trim()
    let hasError = false

    this.$firstname.removeClass(this.classes.inputError)
    this.$lastname.removeClass(this.classes.inputError)
    this.$enterprise.removeClass(this.classes.inputError)
    this.$phone.removeClass(this.classes.inputError)
    this.$email.removeClass(this.classes.inputError)

    if (firstname.length < 2) {
      hasError = true
      this.$firstname.addClass(this.classes.inputError)
      $('#empty_answer_error_firstname').addClass('active')
    } else if (this.validateName(firstname) === null) {
      hasError = true
      this.$firstname.addClass(this.classes.inputError)
      $('#bad_answer_error_firstname').addClass('active')
    }

    if (lastname.length === 0) {
      hasError = true
      this.$lastname.addClass(this.classes.inputError)
      $('#empty_answer_error_lastname').addClass('active')
    } else if (this.validateName(lastname) === null) {
      hasError = true
      this.$lastname.addClass(this.classes.inputError)
      $('#bad_answer_error_lastname').addClass('active')
    }

    if (enterprise.length === 0) {
      hasError = true
      this.$enterprise.addClass(this.classes.inputError)
      $('#empty_answer_error_enterprise').addClass('active')
    }

    if (phone.length === 0) {
      hasError = true
      this.$phone.addClass(this.classes.inputError)
      $('#empty_answer_error_phone').addClass('active')
    } else if (this.validatePhone(phone) === null) {
      hasError = true
      this.$phone.addClass(this.classes.inputError)
      $('#bad_answer_error_phone').addClass('active')
    }

    if (email.length === 0) {
      hasError = true
      this.$email.addClass(this.classes.inputError)
      $('#empty_answer_error_email').addClass('active')
    } else if (this.validateEmail(email) === null) {
      hasError = true
      this.$email.addClass(this.classes.inputError)
      $('#bad_answer_error_email').addClass('active')
    }

    return !hasError
  }

  sendForm() {
    if (this.formProvider === 'odoo') {
      return this.sendFormOdoo()
    }

    let marketoBlankForm = MktoForms2.allForms()[0]

    let firstname = this.$firstname.val().trim()
    let lastname = this.$lastname.val().trim()
    let enterprise = this.$enterprise.val().trim()
    let phone = this.$phone.val().trim()
    let email = this.$email.val().trim()
    let accounts = this.$bankAccountInput.val().trim()
    let pack = this.$packInput.filter(':checked').val().trim()

    let checked = document.querySelectorAll("input[name='form_fields[options][]']:checked")
    let checkedOptions = Array.from(checked).map(c => c.value).join('+')

    let price = this.$container.find('.current-price')
    let priceVal = "calcul non généré"

    if (price.length > 0) {
      priceVal = price.text()
    }

    marketoBlankForm.addHiddenFields({
      // "SOAP API NAME":VAR
      "Email": email,
      "FirstName": firstname,
      "LastName": lastname,
      "Company": enterprise,
      "Phone": phone,
      "External_Comment__c": "Demande : EXALOG, pack sélectionné : "+pack+", nombre de compte bancaire : "+accounts+", options sélectionnées :"+checkedOptions+", montant du devis : "+priceVal
    })

    let hasTYP = false

    if (this.$form.data('typ')) {
      hasTYP = true
      marketoBlankForm.onSuccess(this.handleSuccessFormMarketo.bind(this))
    }

    marketoBlankForm.submit()

    return hasTYP
  }

  /**
   * Odoo equivalent of sendForm(): builds the crm.lead payload from the
   * simulator's collected fields and posts it via the shared Odoo AJAX
   * handler. Always returns true (like the "has a thank you page" Marketo
   * path) since the linked Form CPT always has a thank you page configured;
   * the redirect happens once the AJAX call resolves successfully.
   */
  sendFormOdoo() {
    if (typeof odooForm === 'undefined') {
      return true
    }

    const firstname = this.$firstname.val().trim()
    const lastname = this.$lastname.val().trim()
    const enterprise = this.$enterprise.val().trim()
    const phone = this.$phone.val().trim()
    const email = this.$email.val().trim()
    const accounts = this.$bankAccountInput.val().trim()
    const pack = this.$packInput.filter(':checked').val().trim()

    const checked = document.querySelectorAll("input[name='form_fields[options][]']:checked")
    const checkedOptions = Array.from(checked).map(c => c.value).join('+')

    const price = this.$container.find('.current-price')
    let priceVal = 'calcul non généré'

    if (price.length > 0) {
      priceVal = price.text()
    }

    $.ajax({
      url: odooForm.ajaxUrl,
      type: 'POST',
      dataType: 'json',
      data: {
        action: odooForm.action,
        nonce: odooForm.nonce,
        form_id: this.odooFormId,
        contact_name: firstname,
        contact_lastname: lastname,
        email_from: email,
        mobile: phone,
        partner_name: enterprise,
        description: `Demande : EXALOG, pack sélectionné : ${pack}, nombre de compte bancaire : ${accounts}, options sélectionnées : ${checkedOptions}, montant du devis : ${priceVal}`
      },
      success: (response) => {
        if (response && response.success && response.data && response.data.redirect) {
          window.location.href = response.data.redirect
        }
      }
    })

    return true
  }

  handleSuccessFormMarketo(values, followUpUrl) {
    location.href = this.$form.data('typ')

    return false;
  }

  showPriceSuccess(data) {
    this.$priceContent.prepend(data.data)
    this.$container.find('[data-step="3"] .btn-next').show()
  }

  showPriceError(data) {
    this.$priceContent.prepend(data.data)
  }

  validateEmail(email) {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      )
  }

  validatePhone(phone) {
    return String(phone)
      .toLowerCase()
      .match(
        /^(\+33|0)[1-9]([0-9]{2})?[0-9]{8}$/
      )
  }

  validateName(name) {
    return String(name)
      .toLowerCase()
      .match(
        /^[A-Za-zÀ-ÖØ-öø-ÿ]+([ -][A-Za-zÀ-ÖØ-öø-ÿ]+)*$/
      )
  }
}
